import React, { useEffect, useState } from "react";
import { Box, Card, IconButton,ClickAwayListener, Radio, RadioGroup, FormControlLabel, TextField, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./AddAgent.scss";
import "./../../../styles.scss"

interface RightCardProps {
  isOpen: boolean;
  onClose: () => void;
  addAgentList: any;
  onSubmit: (data: any) => void;
}

const AddAgent: React.FC<RightCardProps> = ({ isOpen, onClose, addAgentList, onSubmit }) => {
  const [step, setStep] = useState(1); // Step navigation
  const [selectedVendor, setSelectedVendor] = useState(
    addAgentList?.accounts?.[0]?.id || ''
  ); // Default vendor
  const [selectedAccountType, setSelectedAccountType] = useState("single_aws");
  const [formData, setFormData] = useState({ name: "", description: "" });
  const [touched, setTouched] = useState({ name: false, description: false });
  const alphaNumPattern = /^[a-zA-Z0-9 ]*$/;

  const isFormValid = () => {
    return (
      formData.name.trim().length >= 3 &&
      formData.name.trim().length <= 20 &&
      alphaNumPattern.test(formData.name) &&
      formData.description.trim().length >= 3 &&
      formData.description.trim().length <= 60 &&
      alphaNumPattern.test(formData.description)
    );
  };


  const getImagePath = (id: string) => new URL(`../../../assets/${id}.svg`, import.meta.url).href;
  const getWhiteImagePath = (id: string) => new URL(`../../../assets/${id}_hover.svg`, import.meta.url).href;
  console.log(getImagePath,'getImagePath');
  console.log(getWhiteImagePath,'getWhiteImagePath');
  
  const getSelectedVendorCategories = () => {
    if (!addAgentList?.accounts || addAgentList.accounts.length === 0) {
      return [];
    }
    const vendor = addAgentList.accounts.find((v: any) => v.id === selectedVendor);
    console.log(vendor, "vendor");
    const categories = vendor ? vendor.categories : [];
    if (categories.length > 0 && !selectedAccountType) {
      setSelectedAccountType(categories[0].code); // Select the first category by default
    }
    return categories;
  };

  const handleAccountTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedAccountType(event.target.value);
  };

  const handleFormChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleNext = () => {
    setStep(step + 1);
  };
  const handleBlur = (field: string) => {
    setTouched({ ...touched, [field]: true }); // Mark the field as touched
  };
  const handleSubmit = () => {
    const selectedCategory = getSelectedVendorCategories().find(
      (category: any) => category.code === selectedAccountType
    );
    const dataToSend = {
      name: formData.name,
      description: formData.description,
      cloud_account_type: selectedCategory?.id,
      "agent_type": "cloud",
    };

    onSubmit(dataToSend);
    onClose();
  };
  useEffect(() => {
    const categories = getSelectedVendorCategories();
    if (categories.length > 0) {
      setSelectedAccountType(categories[0].code);
    }
  }, [selectedVendor]);
     useEffect(() => {
      const handleEsc = (event:any) => {
        if (event.key === "Escape") {
          onClose();
        }
      };
      document.addEventListener("keydown", handleEsc);
      return () => {
        document.removeEventListener("keydown", handleEsc);
      };
    }, [onClose]);
  if (!isOpen) return null;
  return (
     <ClickAwayListener onClickAway={onClose}>
    <Box
      sx={{
        position: "fixed",
        top: 0,
        right: 0,
        height: "100vh",
        width: "320px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        zIndex: 1300,
      }}
    >
      <Card
        sx={{
          width: "100%",
          height: "97vh",
          p: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          borderRadius: "16px",
          boxShadow: 3,
          position: "relative",
        }}
      >
        <div className="cloud-scan-header">
          <div className="header-left">
            <p className="header-title">Cloud Scan</p>
            <p className="header-text">Select the cloud service provider</p>
          </div>
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        {step === 1 && (
          <>
            <hr />
            <div style={{ display: 'grid', gridTemplateRows: '1fr auto', height: '100%' }}>
              <div>
                <div className="cloud-scan-body">

                  {addAgentList?.accounts && addAgentList.accounts.length > 0 ? (
                    addAgentList.accounts.map((vendor: any) => (
                      <div
                        className={`white-box ${selectedVendor === vendor.id ? "active" : ""}`}
                        key={vendor.id}
                        onClick={() => setSelectedVendor(vendor.id)}
                      >
                        <img src={getImagePath(vendor.id)} className="normal-state" alt={vendor.name} />
                        <img src={getWhiteImagePath(vendor.id)} className="hover-state" alt={`${vendor.name}-hover`} />
                      </div>
                    ))
                  ) : (
                    <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                      No cloud providers available. Please configure cloud accounts first.
                    </div>
                  )}
                </div>
                <div>
                  <p>Select between single account or organization.</p>
                  <RadioGroup value={selectedAccountType} onChange={handleAccountTypeChange}>
                    {(() => {
                      const selectedVendorObj = addAgentList?.accounts?.find((v: any) => v.id === selectedVendor);
                      const categories = getSelectedVendorCategories();
                      const hasAvailableCategory = categories.some(
                        (category: any) => selectedVendorObj?.name?.toLowerCase() === "amazon web services" && category.code === "single_aws"
                      );
                      
                      if (hasAvailableCategory) {
                        return categories
                          .filter((category: any) => 
                            selectedVendorObj?.name?.toLowerCase() === "amazon web services" && category.code === "single_aws"
                          )
                          .map((category: any) => {
                            return (
                              <FormControlLabel
                                key={category.id}
                                value={category.code}
                                control={<Radio />}
                                sx={{
                                  display: "flex",
                                  alignItems: "center", // Align items vertically
                                }}
                                label={
                                  <>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                      <p style={{ fontWeight: "bold", marginTop: "20px", fontSize: "14px" }}>
                                        {category.name}
                                      </p>
                                    </div>
                                    <p style={{ margin: 0, fontSize: "12px", color: "#666" }}>
                                      {category.description}
                                    </p>
                                  </>
                                }
                              />
                            );
                          });
                      } else {
                        return (
                          <div style={{ padding: "8px", marginTop: "20px" }}>
                            <p style={{ fontWeight: "bold", fontSize: "14px" }}>Coming soon</p>
                          </div>
                        );
                      }
                    })()}
                  </RadioGroup>
                </div>
              </div>
              <div>
                <Button variant="contained"
                  color="primary" onClick={handleNext} sx={{ width: "100%" }}>
                  Next
                </Button>
              </div>
            </div>
          </>
        )}
        {step === 2 && (
          <>
            <div style={{ display: 'grid', gridTemplateRows: '1fr auto', height: '100%' }}>
              <div>
                <div className="cloud-scan-header">
                  <img src={getImagePath(selectedVendor)} className="normal-state" alt={selectedVendor} />
                </div>
                <TextField
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleFormChange}
                  onBlur={() => handleBlur("name")}
                  fullWidth
                  required
                  margin="normal"
                  inputProps={{ minLength: 3, maxLength: 20 }}
                  error={
                    touched.name &&
                    (
                      formData.name.trim().length < 3 ||
                      formData.name.trim().length > 20 ||
                      !alphaNumPattern.test(formData.name)
                    )
                  }
                  helperText={
                    touched.name &&
                    (
                      formData.name.trim().length < 3
                        ? "Name must be at least 3 characters."
                        : formData.name.trim().length > 20
                          ? "Maximum 20 characters allowed"
                          : !alphaNumPattern.test(formData.name)
                            ? "Special characters not allowed"
                            : ""
                    )
                  }
                />
                <TextField
                  label="Description"
                  name="description"
                  value={formData.description}
                  onChange={handleFormChange}
                  onBlur={() => handleBlur("description")}
                  fullWidth
                  required
                  margin="normal"
                  inputProps={{ minLength: 3, maxLength: 60 }}
                  error={
                    touched.description &&
                    (
                      formData.description.trim().length < 3 ||
                      formData.description.trim().length > 60 ||
                      !alphaNumPattern.test(formData.description)
                    )
                  }
                  helperText={
                    touched.description &&
                    (
                      formData.description.trim().length < 3
                        ? "Description must be at least 3 characters."
                        : formData.description.trim().length > 60
                          ? "Maximum 60 characters allowed"
                          : !alphaNumPattern.test(formData.description)
                            ? "Special characters not allowed"
                            : ""
                    )
                  }
                />
              </div>
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={!isFormValid()}
                  sx={{ width: "100%" }}
                >
                  Submit
                </Button>
              </div>
            </div>
          </>
        )}
      </Card>
    </Box>
    </ClickAwayListener>
  );
};

export default AddAgent;